import { cloneDeep } from 'lodash';
import { UUID } from 'v2/core/entities/uuid';
import {
  NormalisedFilterGroup,
  NormalisedNode,
} from 'v2/querybuilder/types/querystore';

interface upsertMultipleQueryFilterNodeParams {
  nodesToUpsert: NormalisedNode[];
  groupNodeToUpsert?: NormalisedFilterGroup;
  rootID?: UUID;
  nodesByID: Record<string, NormalisedNode>;
}

export function upsertMultipleQueryFilterNodes({
  nodesToUpsert,
  groupNodeToUpsert,
  rootID,
  nodesByID,
}: upsertMultipleQueryFilterNodeParams) {
  const updatedNodes = cloneDeep(nodesByID);
  const parentID = groupNodeToUpsert?.id ?? rootID;

  // Probably not required, added for safety,
  // same as: src/v3/modules/queryBuilder/helpers/upsertQueryFilterNode.ts
  if (!parentID) {
    nodesToUpsert.forEach((node) => {
      updatedNodes[node.id] = node;
    });
    return updatedNodes;
  }

  if (
    groupNodeToUpsert &&
    rootID &&
    !updatedNodes[rootID]?.children?.includes(groupNodeToUpsert.id)
  ) {
    updatedNodes[rootID].children = [
      ...(updatedNodes[rootID]?.children ?? []),
      groupNodeToUpsert.id,
    ];
  }

  if (groupNodeToUpsert && !updatedNodes[parentID]) {
    updatedNodes[groupNodeToUpsert.id] = groupNodeToUpsert;
  }

  const group = updatedNodes[parentID];

  if (group.type !== 'group') {
    console.error("Can't add child to filter");
    return updatedNodes;
  }

  nodesToUpsert.forEach((node) => {
    updatedNodes[node.id] = {
      ...node,
      parent: parentID,
    };

    if (!group.children.includes(node.id)) {
      group.children = [...group.children, node.id];
    }
  });

  return updatedNodes;
}
